import Button from '@components/Button'
import { TokenCard } from '@modules/Swap/ExchangeView'
import { Divider, List, ListItem, Paper, Stack, Typography } from '@mui/material'
import useMintCycles from '@plug-core/hooks/useMintCycles'
import { logger } from '@plug-core/logger'
import { formatNumber } from '@plug-core/utils/formatNumber'
import React, { PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

const MintCyclesListItem = ({
  attribute,
  children,
}: PropsWithChildren & {
  attribute: string
}) => (
  <ListItem
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      my: 1,
    }}
  >
    <Typography variant="body2">{attribute}</Typography>
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Stack>
  </ListItem>
)

const MintCycles = () => {
  const navigate = useNavigate()

  const {
    inputAmount,
    setInputAmount,
    outAmount,
    icpToken,
    conversionRate,
    error,
    mintInProgress,
    performCyclesMint,
  } = useMintCycles()

  return (
    <Stack mx={2} spacing={1.25}>
      <TokenCard
        token={{ ...icpToken!, id: icpToken!.address }}
        amount={inputAmount}
        setAmount={setInputAmount}
        mode="stake"
        error={undefined}
        showBalance
        disableTokenPicker
      />
      <List component={Paper} disablePadding>
        <MintCyclesListItem attribute="You receive">
          {formatNumber(outAmount, 'TC')}
        </MintCyclesListItem>
        <Divider sx={{ borderColor: 'background.default' }} />
        {conversionRate && (
          <MintCyclesListItem attribute="Conversion rate">
            1 ICP = {formatNumber(conversionRate, 'TC')}
          </MintCyclesListItem>
        )}
      </List>
      <Button
        variant="rainbow"
        disabled={!!error}
        loading={mintInProgress}
        onClick={() =>
          performCyclesMint()
            .then(() => navigate(-1))
            .catch(logger.error)
        }
        fullWidth
      >
        {error || 'Mint cycles'}
      </Button>
    </Stack>
  )
}

export default MintCycles
